import { useMemo } from 'react';
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import { formatCentsToDollars } from 'marketplace-ui-common/utils/currency';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CurrencyText({
  cents
}) {
  const dollars = useMemo(() => formatCentsToDollars(cents), [cents]);
  if (dollars % 1) {
    return /*#__PURE__*/_jsx(FormattedCurrency, {
      value: dollars,
      currencyCode: "USD"
    });
  }
  return /*#__PURE__*/_jsx(FormattedCurrency, {
    value: dollars,
    simplifyCurrency: true,
    currencyCode: "USD"
  });
}